export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: false,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_mrpOutsourcingOrderNo') || '委外订单编号',
    field: 'mrpOutsourcingOrderNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_outsourcingOrderStatus') || '委外订单状态',
    field: 'outsourcingOrderStatus',
    headerAlign: 'center',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
    slots: { default: 'status' }
  },
  {
    title: that.$l('table_label_orderDate') || '下单日期',
    field: 'orderDate',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_expectedDeliveryDate') || '预计交货日期',
    field: 'expectedDeliveryDate',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.purchase_form_label_scmName') || '供应商',
    field: 'scmName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_buyerName') || '采购人员',
    field: 'buyerName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_contactMemo') || '备注',
    field: 'remark',
    headerAlign: 'center',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.creator') || "创建人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: {
      default: "createInfo",
    },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || "修改人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "modifyInfo" },
  },

]
